import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css'; // For react-toastify styling

export default function Toasts() {
    return (
        <ToastContainer position="bottom-right" autoClose={4000} transition={Zoom} limit={3} theme="colored"/>
    )
}